import Backbone from 'backbone';
import PreviewTempalteModal from './previewTemplate';
var commonFunction = require('./common.js');
var sourceFile = require('../../../config/config.js');

const url = sourceFile.url;

export default Backbone.View.extend({
  initialize() {
    this.commands = editor.Commands;
  },

  events: {
    'click .templates-item': 'itemClicked'
  },

  template({ name, image }) {
    return `
              <div class="img">
                <img src="${image}">
              </div>
              <div class="name"> ${name} </div>
        `;
  },

  renderTemplate(model) {
    this.$el.append(this.template(model.toJSON()));
  },
  itemClicked(e) {
    const { model, commands } = this;
    let command = commands.get('open-template-preview');
    let options = {
      template_id: model.get('template_id'),
      command: 'open-template-preview',
      group_name: model.get('group_name')
    };
    commands.runCommand(command, { ...options, sender: model });
  },
  render: function() {
    this.$el.empty();
    this.$el.addClass('templates-item');
    this.$el.append(this.template(this.model.toJSON()));
    return this;
  }
});
